import React from 'react';
import { BiCopy } from 'react-icons/bi';

export const CardCopyIVData = ({ copyHandler, copyText }: any) => {
    return (
        <div className="h-100">
            <div className="d-flex h-100">
                <textarea
                    name="description"
                    className="h-100 w-100 form-control default-radius border-primary text-muted bg-white"
                    rows={3}
                    disabled={true}
                    defaultValue={copyText}
                ></textarea>
                <BiCopy
                    className="font-22 cursor-pointer z-index-2 mb-2 mt-auto textHover text-primary "
                    style={{ marginLeft: '-2rem' }}
                    onClick={() => copyHandler(copyText)}
                />
            </div>
        </div>
    );
};
